export default {
  "menu.home": "首页",
  "menu.history": "历史数据",
  "menu.deviceManagement": "设备管理",
  "menu.settings": "设置",
  "menu.messageCenter": "消息中心",
  "menu.help": "帮助与支持",
  "menu.mine": "我的",
};
